// extracted by mini-css-extract-plugin
export default {"favorites_container":"Favorites_favorites_container__6TWFQ","favorites_grid":"Favorites_favorites_grid__CUAzM","no_favorites":"Favorites_no_favorites__PwPJj"};